var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/assets/images/logo/logo.png?vue&type=custom&index=0&blockType=img&issuerPath=C%3A%5Claragon%5Cwww%5Cfrontend%5Csrc%5C%40core%5Clayouts%5Ccomponents%5CLogo.vue&height=50&alt=true"
if (typeof block0 === 'function') block0(component)

export default component.exports